import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/icon-expand.svg'


const _hoisted_1 = {
  key: 0,
  class: "main-wr",
  id: "floorplanStep"
}
const _hoisted_2 = {
  key: 0,
  class: "content-house-design-features"
}
const _hoisted_3 = { class: "content-house-design" }
const _hoisted_4 = { class: "title-house-design" }
const _hoisted_5 = {
  key: 0,
  class: "area-house-design"
}
const _hoisted_6 = { class: "content-features" }
const _hoisted_7 = { class: "content-floorplan" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "house-info"
}
const _hoisted_10 = { class: "house-info-cards-wr" }
const _hoisted_11 = {
  key: 0,
  class: "house-info-card"
}
const _hoisted_12 = { class: "house-info-card-row-modified" }
const _hoisted_13 = { class: "row-value" }
const _hoisted_14 = { class: "house-info-card-row-modified" }
const _hoisted_15 = { class: "row-value" }
const _hoisted_16 = { class: "house-info-card-row-modified" }
const _hoisted_17 = { class: "row-value" }
const _hoisted_18 = {
  key: 1,
  class: "house-info-card"
}
const _hoisted_19 = { class: "house-info-card-row-modified" }
const _hoisted_20 = { class: "row-label features" }
const _hoisted_21 = {
  key: 2,
  class: "house-info-card"
}
const _hoisted_22 = { class: "house-info-card-column-modified" }
const _hoisted_23 = { class: "row-label" }
const _hoisted_24 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.selectedHouseDesign)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!$props.isFeaturesHidden)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString($setup.selectedHouseDesign?.name), 1),
                ($setup.isDesktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.formatMeters($setup.selectedHouseDesign?.area, false)) + " sqm", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode($setup["HouseFeatures"], {
                  features: $setup.selectedHouseDesign ?? _ctx.house,
                  class: _normalizeClass($setup.isDesktop ? 'house-features' : 'house-features-mobile')
                }, null, 8, ["features", "class"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            class: "img-floorplan",
            src: $setup.selectedHouseDesign?.floorplans[0]?.url,
            onClick: $setup.openImageModal
          }, null, 8, _hoisted_8),
          ($setup.isDesktop)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "icon-expand",
                src: _imports_0,
                onClick: $setup.openImageModal
              }))
            : _createCommentVNode("", true),
          _createVNode($setup["BuilderLightboxImages"], {
            isOpen: $setup.isImageModalOpen,
            imageUrl: $setup.selectedHouseDesign?.floorplans[0]?.url,
            zoom: $setup.zoom,
            onUpdateZoom: $setup.updateZoom,
            onClose: $setup.closeImageModal
          }, null, 8, ["isOpen", "imageUrl", "zoom"]),
          ($setup.selectedHouseDesign && !$setup.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  ($setup.selectedHouseDesign)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title" }, "Floor Plan Area", -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_12, [
                            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row-label" }, "Area:", -1)),
                            _createElementVNode("div", _hoisted_13, _toDisplayString($setup.formatMeters($setup.selectedHouseDesign.area, false)) + " SQM", 1)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row-label" }, "Width:", -1)),
                            _createElementVNode("div", _hoisted_15, _toDisplayString($setup.formatMeters($setup.selectedHouseDesign.width, false)) + " M", 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row-label" }, "Length:", -1)),
                            _createElementVNode("div", _hoisted_17, _toDisplayString($setup.formatMeters($setup.selectedHouseDesign.length, false)) + " M", 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.selectedHouseDesign?.features)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "Features", -1)),
                        _createElementVNode("div", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedHouseDesign.features, (feature) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, _toDisplayString(feature), 1)
                            ]))
                          }), 256))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.selectedHouseDesign?.inclusions)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title" }, "Inclusions", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedHouseDesign.inclusions, ({ name, url }) => {
                          return (_openBlock(), _createElementBlock("div", null, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, _toDisplayString(name), 1),
                              _createElementVNode("a", {
                                class: "row-value highlighted",
                                href: url,
                                target: "_blank"
                              }, "Download", 8, _hoisted_24)
                            ])
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}